import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});
axiosInstance.interceptors.request.use(
  (config: any) => {
    const user = localStorage.getItem("infoSignin");
    if (!!user) {
      try {
        const parse = JSON.parse(user);

        if (parse?.accessToken !== undefined) {
          config.headers.Authorization = "Bearer " + parse.accessToken;
          return config;
        }
      } catch (error) {
        return config;
      }
    }
    return config;
  },
  (error: any) => {
    console.log("error axios: ", error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log("error: ", error);
    switch (error.response.status) {
      case 401:
        toast.error("Token Expired Error");
        window.location.href = "/signin";
        break;
      case 403:
        toast.error("Your account has not been added by an administrator");
        window.location.href = "/signin";
        break;
      case 500:
        toast.error("Internal server error");
        break;
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
